import { connect } from "react-redux";
import Login from "../components/Login";
import { requestLogin, clearLoginStatus } from "../actions/loginActions";

function mapStateToProps( state, ownProps ) {
    return {
        status: state.login.loginStatus
    }
}

function mapDispatchToProps( dispatch, ownProps ) {
    return {
        onSubmit: login => requestLogin( dispatch, login ),
        clearStatus: () => dispatch( clearLoginStatus() )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( Login );